import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const drawerWidth = 240;

const SidebarLayout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [pcSidebarVisible, setPcSidebarVisible] = React.useState(true);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 600);

  // 画面幅に応じてモバイル状態を更新する関数
  const updateIsMobile = () => {
    const isNowMobile = window.innerWidth < 600;
    setIsMobile(isNowMobile);

    // モバイルになった場合のみサイドバーを閉じる
    if (isNowMobile) {
      setMobileOpen(false);
    }
  };

  useEffect(() => {
    updateIsMobile(); // 初回レンダリング時に状態を設定
    window.addEventListener("resize", updateIsMobile); // 画面幅変更時に状態を更新

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setPcSidebarVisible(!pcSidebarVisible);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "grey.100",
        minHeight: "100vh",
      }}
    >
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: pcSidebarVisible ? `calc(100% - ${drawerWidth}px)` : "100%" },
          ml: { sm: pcSidebarVisible ? `${drawerWidth}px` : 0 },
        }}
      >
        <Toolbar>
          {(!pcSidebarVisible || isMobile) && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                mr: 2,
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography variant="h6" noWrap component="div">
            ARグッズ管理システム
          </Typography>
        </Toolbar>
      </AppBar>

      <Sidebar
        drawerWidth={drawerWidth}
        mobileOpen={mobileOpen}
        handleDrawerTransitionEnd={() => {}}
        handleDrawerClose={() => setMobileOpen(false)}
        handleDrawerToggle={handleDrawerToggle}
        pcSidebarVisible={pcSidebarVisible}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: pcSidebarVisible ? `calc(100% - ${drawerWidth}px)` : "100%" },
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default SidebarLayout;
